// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"c8d7970f","703":"a7aa235e","787":"9988ab38"}[chunkId] + ".chunk.js";
};